<template>
  <v-container fluid>
    <v-progress-linear
      v-if="$vars.loading"
      indeterminate
      class="primary--text loader"
    ></v-progress-linear>
    <v-toolbar dense flat>
      <v-btn text :to="'/stammbaum/daten'" class="hidden-xs-only">Daten</v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-autocomplete single-line solo flat :items='bbrbbr' label='Bundesbruder' v-model='bundesbruder'></v-autocomplete>
        <v-autocomplete single-line solo flat :items='leibfamilienGrunder' label='Leibfamilien' v-model='bundesbruder' class="hidden-xs-only"></v-autocomplete>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon @click="collapse = !collapse" v-on="on"><v-icon>{{ collapse ? 'unfold_more' : 'unfold_less' }}</v-icon></v-btn>
        </template>
        <span>Kollapse</span>
      </v-tooltip>
    </v-toolbar>
    <v-divider></v-divider>
    <v-row no-gutters>
      <v-col cols="12" md="6" offset-md="3">
      </v-col>
    </v-row>
    <v-sheet id="container" class="align-center" :height="screenHeight - 169">
      <stammbaum v-if="currentbundesbruder" :dense="true" :collapse="collapse" :bbr="currentbundesbruder" :currentBbr="currentbundesbruder.id"></stammbaum>
    </v-sheet>
  </v-container>
</template>

<script>
  import stammbaum from '@/module/submodule/stammbaum'
  export default {
    components: {
      stammbaum
    },
    data () {
      return {
        screenWidth: this.$vuetify.breakpoint.width,
        screenHeight: this.$vuetify.breakpoint.height,
        search: '',
        bundesbruder: '',
        denseStammbaum: true,
        bbrbbr: [],
        leibfamilienGrunder: [],
        sidenav: false,
        collapse: false
      }
    },
    computed: {
      currentbundesbruder () {
        if (this.bundesbruder.id) {
          return this.$store.getters['bbrbbr/bbr'](this.bundesbruder.id)
        } else {
          let bbr = ''
          if (this.$firebase.auth().currentUser) {
            this.$store.state.bbrbbr.bbrbbr.forEach(item => {
              if (item.anmeldeID === this.$firebase.auth().currentUser.uid) {
                bbr = item
              }
            })
          }
          return bbr
        }
      }
    },
    methods: {
      test () {

      }
    },
    beforeMount () {
      this.bbrbbr = []
      this.leibfamilienGrunder = []
      let bbrbbr = this.$store.getters['bbrbbr/nurBbrbbr']
      bbrbbr.forEach(item => {
        this.bbrbbr.push({
          value: {
            id: item.id,
            text: item.nachname + ', ' + item.vorname
          },
          text: item.nachname + ', ' + item.vorname
        })
        if (!item.leibvater) {
          this.leibfamilienGrunder.push({
            value: {
              id: item.id,
              text: item.nachname + ', ' + item.vorname
            },
            text: 'Leibfamilie ' + item.nachname + ' (' + item.vorname + ')'
          })
        }
      })
    }
  }
</script>

<style scoped>
#container {
  height: calc(100vh - 160px);
  width: 100%;
  overflow: auto;
 }
</style>



// WEBPACK FOOTER //
// Uebersicht.vue?32f7e276